import {TranslationKeyTransaction} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_TRANSACTION_EN: TranslationResource<TranslationKeyTransaction> = {
  translation: {
    'transaction:cancelTransactionModalMessage':
      'Are you sure you want to cancel this transaction?',
    'transaction:cartDoubleBookedDescription':
      'Complete the payment, or check the transaction history.',
    'transaction:cartDoubleBookedTitle': 'Content Has Been Ordered',
    'transaction:checkTransaction': 'Check Transaction',
    'transaction:checkoutContentCollabRepost':
      'Collab Repost • Your username will be displayed.',
    'transaction:checkoutContentPrice': 'Price',
    'transaction:checkoutContentRepost':
      'Repost to homefeed, fototree, account profile.',
    'transaction:checkoutContentServiceFee': 'Service Fee',
    'transaction:checkoutContentTeenNotice':
      'Reposting is not allowed for teen accounts.',
    'transaction:checkoutTransactionDate': 'Transaction Date',
    'transaction:checkoutTransactionTitle': 'Transaction Detail',
    'transaction:checkoutTransactionType': 'Transaction Type',
    'transaction:checkoutWaitForHiresInfoDesc1':
      'The Hi-Res will appears in the “Collections” at “FotoYu” tab.',
    'transaction:checkoutWaitForHiresInfoDesc2':
      'You can also chat the creator seller by clicking the message icon below each content you purchased.',
    'transaction:checkoutWaitForHiresInfoDesc3':
      'Creators need to resend Hi-Res in 48 hours, or you will get a refund.',
    'transaction:checkoutWaitForHiresInfoTitle':
      'Please wait for the Hi-Res version.',
    'transaction:checkoutUseAnotherBrowser':
      'If there is a problem, try using another browser.',
    'transaction:creditCardLastFour': '(******{{number}})',
    'transaction:paymentFailedModalMessage':
      'Payment cannot be processed this time, please try again later',
    'transaction:paymentIssue': 'Having payment issue?',
    'transaction:qrisDownloadSuccess': 'QRIS downloaded.',
    'transaction:qrisInstructionContentA': '1. Download the QRIS code.',
    'transaction:qrisInstructionContentB':
      '2. Open your bank / e-wallet app that supports QRIS payment.',
    'transaction:qrisInstructionContentC':
      '3. Scan / upload the downloaded QRIS code.',
    'transaction:qrisInstructionContentD':
      '4. Make sure that all the payment informations are correct.',
    'transaction:qrisInstructionContentE':
      '5. Continue the payment process until successful.',
    'transaction:qrisInstructionTitle': 'Payment Instruction:',
    'transaction:qrisSubheader': 'This page is not proof of payment.',
    'transaction:repeatOrder': 'Repeat the Order',
  },
}
